import Glide from '@glidejs/glide';
import LazyLoad from "vanilla-lazyload";

let translatedText = {};
(async function getTranslatedText() {
    translatedText = await import('../../lang/' + window.appLocale + '.json');
})();
require("fslightbox");

window.lazyLoad = new LazyLoad({
    unobserve_entered: true,
    restore_on_error: true,
});

window.lazyLoad.update();

document.addEventListener('DOMContentLoaded', () => {
    addArrowIconEventListener();
    scrollToBookings();
    getNotificationsNumber();
    setTimeout(() => {
        // Delay to ensure DOM updates
        toggleCarousel();
    }, 500);
    initializeCarousel();
    initLazyLoadVideos();
    initAutoplayVideoFromHash();
    initShareButtons();
});

document.addEventListener(
    "ready-for-carousel",
    (e) => {
        toggleCarousel();
    },
    false,
);

const addArrowIconEventListener = () => {
    const headerImage = document.getElementsByClassName('arrow-icon');
    const container = document.getElementsByClassName('container-2-p');

    if (headerImage[0]) {
        headerImage[0].addEventListener('click', ($event) => {
            container[0].classList.toggle('active-container-2-p');
            headerImage[0].classList.toggle('active-icon');
        });
    }
}

let glideInstances = [];

let mountCarousel = (element) => {

    glideInstances.forEach(glide => {
        if (element.id === glide.selector.id) {
            try {
                const oldNav = element.querySelector('.carousel-nav');
                const newNav = oldNav.cloneNode(true);
                oldNav.parentNode.replaceChild(newNav, oldNav);
                glide.destroy();
                glideInstances = glideInstances.filter(g => g.selector.id !== glide.selector.id);
            } catch (e) {
                console.log(e);
            }
        }
    });

    const glide = new Glide(element, {
        type: 'carousel',
        perView: 6,
        gap: 10,
        startAt: 0,
        breakpoints: {
            1380: {
                perView: 4
            },
            960: {
                perView: 3
            },
            767: {
                perView: 2
            },
        }
    });

    glideInstances.push(glide);

    const glideArrowLeft = element.querySelector('.carousel-nav .arrow-icon-left');
    const glideArrowRight = element.querySelector('.carousel-nav .arrow-icon-right');

    glideArrowLeft.addEventListener('click', function () {
        glide.go('<');
    });
    glideArrowRight.addEventListener('click', function () {
        glide.go('>');
    });

    glide.mount();
}

const toggleCarousel = () => {
    const galleryBtns = document.querySelectorAll('.gallery-switch');
    const carouselBtns = document.querySelectorAll('.carousel-switch');
    const mq = window.matchMedia("(max-width: 960px)");

    if (galleryBtns) {
        galleryBtns.forEach(galleryBtn => {
            galleryBtn.addEventListener('click', () => {

                let container = galleryBtn.closest('.gallery-list-holder');
                let targets = container.querySelectorAll('.grid-list');

                galleryBtn.nextElementSibling.classList.remove('active');
                galleryBtn.classList.add('active');
                if (targets) {
                    targets.forEach(target => {
                        glideInstances.forEach(glide => {
                            if (target.id === glide.selector.id) {
                                try {
                                    const oldNav = target.querySelector('.carousel-nav');
                                    const newNav = oldNav.cloneNode(true);
                                    oldNav.parentNode.replaceChild(newNav, oldNav);
                                    glide.destroy();
                                    glideInstances = glideInstances.filter(g => g.selector.id !== glide.selector.id);
                                } catch (e) {
                                    console.log(e);
                                }
                            }
                        })
                        target.classList.remove('carousel-list');
                    });
                }
            })
        })
    }

    if (carouselBtns) {
        carouselBtns.forEach(carouselBtn => {
            carouselBtn.addEventListener('click', () => {
                let container = carouselBtn.closest('.gallery-list-holder');
                let targets = container.querySelectorAll('.grid-list');

                if (targets) {
                    targets.forEach(target => {
                        let items = target.querySelectorAll('.grid-list__item');
                        if (items.length > 5) {
                            carouselBtn.classList.add('active');
                            carouselBtn.previousElementSibling.classList.remove('active');
                            target.classList.add('carousel-list');
                            mountCarousel(target);
                        }
                    });
                }
            })
        })

        let escortGallery = document.getElementById('js-escortGallery');

        if (mq.matches && escortGallery) {
            setTimeout(function () {
                carouselBtns.forEach(carouselBtn => {
                    carouselBtn.click();
                });
            }, 300);
        }
    }

    let carousels = document.querySelectorAll('.carousel-initial');
    if (carousels) {

        carousels.forEach(carousel => {
            let container = carousel.closest('.gallery-list-holder');
            let carouselsControl = container.querySelector('.carousel-switch');
            let gridControl = container.querySelector('.gallery-switch');
            let items = container.querySelectorAll('.grid-list__item');

            if (carousels && items.length > 5) {
                if (carouselsControl.classList.contains('active')) {
                    carouselsControl.click();
                }
            } else {
                gridControl.click();
            }
        });
    }
    window.lazyLoad.update();
}

// Toggle active class
const activeToggle = document.getElementsByClassName('js-activeToggle');

if (activeToggle) {

    function toggleActiveClass() {
        const closestToggleParent = this.parentNode.closest('.js-toggled');
        closestToggleParent.classList.toggle('active');
    }

    Array.from(activeToggle).forEach(function (element) {
        element.addEventListener('click', toggleActiveClass);
    });
}

// Toggle mobile Menu
const toggleMenuButton = document.getElementsByClassName("js-menuIcon");

if (toggleMenuButton) {

    function toggleMenu() {
        document.body.classList.toggle('menu-active');
    }

    Array.from(toggleMenuButton).forEach(function (element) {
        element.addEventListener('click', toggleMenu);
    });
}

function readNotification(notificationId) {
    try {
        axios.post('/confirmation-notification/read-notification', {notificationId});
    } catch (e) {
        console.error(e);
    }
}

function scrollToBookings() {
    if (window.location.pathname != '/profile') return;
    const params = new URLSearchParams(window.location.search);
    const scrollTo = params.get("scroll");

    if (scrollTo != "bookings") return;

    const element = document.getElementById("bookings");
    if (!element) return;
    setTimeout(() => {
        element.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
        params.delete("scroll");
        const newUrl = window.location.pathname + '?' + params.toString();
        window.history.replaceState({}, '', newUrl);
    }, 200);
}

function addNotificationsEvents() {
    setTimeout(() => {
        document.querySelectorAll('.notification').forEach(notification => {
            notification.addEventListener('click', function () {
                const id = this.getAttribute('data-id');
                const isRead = this.getAttribute('data-read');
                const redirectUrl = this.getAttribute('data-redirect-url');
                if (isRead == 'false') readNotification(id);
                window.location.href = redirectUrl || '/profile';

            });
        });

    }, 200)

}

function addNotificationsNumber(number) {
    const notificationBadge = document.querySelector('.notification-count');
    if ((notificationBadge) && (number) && (number > 0)) {
        notificationBadge.textContent = number;
        notificationBadge.style.display = 'inline-block';
    }
}

async function getNotificationsNumber() {
    try {
        const data = await axios.get('/confirmation-notification/unread-count');
        if (!isNaN(data.data)) addNotificationsNumber(data.data);
    } catch (e) {
        console.error(e);
    }
}

// Toggle Bell Menu
const toggleBellButton = document.getElementsByClassName("js-bellIcon");
const contentBell = document.querySelector('.mobile-content-bell');
const notificationBadge = document.querySelector('.notification-count');

async function markAllAsRead() {
    try {
        const ok = await axios.post('/confirmation-notification/read-all')
        document.body.classList.toggle('bell-active');
        if (notificationBadge) {
            notificationBadge.textContent = '0';
            notificationBadge.style.display = 'none';
        }
    } catch (e) {
        console.error(e);
    }
}

function addEventAtRead() {
    setTimeout(() => {
        document.getElementById('markAllAsReadButton').addEventListener('click', markAllAsRead);
    }, 200);
}

if (toggleBellButton) {

    async function getContent() {
        try {
            const data = await axios.get('/confirmation-notification', {
                params: {
                    language: window.appLocale
                }
            });
            if (data?.data?.length) return data?.data
            return [];
        } catch (e) {
            console.error(e);
            return [];
        }
    }

    function calculateTimeDistance(created_at) {
        const messageDateTime = new Date(created_at);
        const now = new Date();
        const diffInMs = now - messageDateTime;
        const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));

        if (diffInHours >= 24) {
            const diffInDays = Math.floor(diffInHours / 24);
            return `${diffInDays}
            ${diffInDays > 1 ? translatedText['days'] : translatedText['day']}
            ${translatedText['ago']}`;
        } else if (diffInHours === 0) {
            return translatedText['A few moments ago'];
        } else {
            return `${diffInHours}
            ${diffInHours !== 1 ? translatedText['hours'] : translatedText['hour']}
            ${translatedText['ago']}`;
        }
    }

    async function toggleMenu() {
        document.body.classList.toggle('bell-active');
        if (!document.body.classList.contains('bell-active')) {
            return;
        }
        const notifications = await getContent();
        let content = [];
        notifications.forEach((notification) => {
            const title = notification.is_read
                ? `<p><strong>${notification.escort_name ? notification.escort_name : 'Society'}</strong> ${translatedText["sent you a message"]}: </p>`
                : `<p><a><strong>${notification.escort_name ? notification.escort_name : 'Society'}</strong> ${translatedText["sent you a message"]}: </a></p>`;

            const greenDot = notification.is_read ? '' : `<span class="status-dot"></span>`;
            const image = notification.escort_image ? `<img class="escort-img" src="/uploads/${notification.escort_image}" alt="Escort Image" />` : ''

            content.push(`
                <div class="notification" data-id="${notification.id}" data-read="${notification.is_read}" data-redirect-url="${notification.redirect_url || '/profile'}">
                    <div class="avatar-container">
                        <div class="image-wrapper">
                            ${greenDot}
                            ${image}
                        </div>
                    </div>
                    <div class="message-content">
                        ${title}
                        <p>${notification.body}</p>
                        <p class="time-distance">${calculateTimeDistance(notification.created_at)}</p>
                    </div>
                </div>
            `);
        });


        if (notifications?.length) {
            contentBell.innerHTML = `
                <div class="notifications-container">
                    <h4 class="notification-title ">${translatedText['Notifications']}</h4>
                    ${content.join('')}
                </div>
                <div class="button-container">
                    <button id="markAllAsReadButton"><a>${translatedText['MARK ALL AS READ']}</a></button>
                </div>
            `;
            addEventAtRead();
            addNotificationsEvents();
        } else {
            contentBell.innerHTML = `
                <div class="notifications-container">
                    <h4 class="notification-title ">${translatedText["You currently do not have any messages to display"]}</h4>
                </div>
            `;
        }

    }

    Array.from(toggleBellButton).forEach(function (element) {
        element.addEventListener('click', toggleMenu);
    });
}

// Site search toggle
const siteSearch = document.querySelector('.header-site-search')
const siteSearchInput = document.querySelector('.header-site-search-input')
const nav = document.querySelector('.js-nav')

if (siteSearch) {
    document.addEventListener('click', (event) => {
        const withinBoundaries = event.composedPath().includes(siteSearch)

        if (withinBoundaries) {
            siteSearch.classList.add('active');

            setTimeout(function () {
                if (siteSearchInput) {
                    siteSearchInput.focus();
                }
            }, 100);
        } else {
            if (!event.composedPath().includes(nav)) {
                siteSearch.classList.remove('active');
            }
        }
    })
}

const siteSearchOverlay = document.querySelector('.header-site-search-overlay')
const siteSearchInputOverlay = document.querySelector('.header-site-search-input-overlay')

if (siteSearchOverlay) {
    document.addEventListener('click', (event) => {
        const withinBoundariesO = event.composedPath().includes(siteSearchOverlay)

        if (withinBoundariesO) {
            siteSearchOverlay.classList.add('active');

            setTimeout(function () {
                if (siteSearchInputOverlay) {
                    siteSearchInputOverlay.focus();
                }
            }, 100);
        } else {
            siteSearchOverlay.classList.remove('active');
        }
    })
}
// end Site search toggle

// To top btn
const toTopBtn = document.getElementById('js-toTopBtn')

function scrollFunctionTop() {
    if (toTopBtn) {
        if (document.body.scrollTop > 300 || document.documentElement.scrollTop > 300) {
            toTopBtn.classList.add('visible');
        } else {
            toTopBtn.classList.remove('visible');
        }
    }
}

toTopBtn.addEventListener('click', () => {
    window.scrollTo(0, 0);
});


// Detached header
function scrollFunctionDetach() {
    if (document.body.scrollTop > 300 || document.documentElement.scrollTop > 300) {
        document.body.classList.add('detached-header');
    } else {
        document.body.classList.remove('detached-header');
    }
}

window.onscroll = function () {
    scrollFunctionDetach();

    if (toTopBtn) {
        scrollFunctionTop();
    }
};

// Tabbed content
const tabs = document.querySelectorAll(".js-tabButton")

tabs.forEach(tab => {
    tab.addEventListener('click', () => {

        let parentTab = tab.closest('.js-tabs');
        let tabContents = parentTab.querySelectorAll('.js-tab');
        let siblingButtons = parentTab.querySelectorAll('.js-tabButton');

        tabContents.forEach(tabContent => {
            tabContent.classList.remove('active')
        })

        siblingButtons.forEach(siblingButton => {
            siblingButton.classList.remove('active')
        })

        tab.classList.add('active')
        let target = document.getElementById(tab.dataset.tabTarget);
        target.classList.add("active");
    })
})

// Toggle collapsible content on mobile
let collapsibleSection = document.querySelectorAll('.jsCollapsibleSection');

if (collapsibleSection) {
    let collapsibleHandlers = document.querySelectorAll('.jsCollapsibleHandler');

    collapsibleHandlers.forEach(collapsibleHandler => {
        collapsibleHandler.addEventListener('click', () => {
            let parentSection = collapsibleHandler.closest('.jsCollapsibleSection');
            parentSection.classList.toggle('active-section');
        })
    })
}

// Bookings carousel

const $carousel = document.querySelector('.bookings-carousel');
let startX = 0;
let endX = 0;

function getSeats() {
    return Array.from(document.querySelectorAll('.bookings-carousel__item'));
}

let $seats = getSeats();

if ($seats.length > 1) {
    document.querySelector('.bookings-carousel__step').classList.add('visible');
    $carousel.classList.add('multiple');
}

if ($seats.length === 2) {
    $carousel.classList.add('double');
}

let $totalBookings = document.querySelector('.bookings-total');
if ($totalBookings) {
    $totalBookings.innerHTML = $seats.length;
}

document.addEventListener("click", delegateBooking(toggleBookingFilter, toggleBookingHandler));

function delegateBooking(criteria, listener) {
    return function (e) {
        let el = e.target;
        while (el) {
            if (criteria(el)) {
                e.delegateTarget = el;
                listener.call(this, e);
                return;
            }
            el = el.parentNode;
        }
    };
}

function initializeCarousel() {
    let $seats = getSeats();
    if ($seats.length === 0) return;

    $seats[0].classList.add('is-ref', 'visible');
}

function toggleBookingFilter(elem) {
    return elem instanceof HTMLElement && elem.matches(".nav-arrow");
}

let $bookingStep = document.querySelector('.bookings-current-step');

function toggleBookingHandler(e) {
    let $seats = getSeats();
    let $newSeat;
    const $el = document.querySelector('.is-ref');
    const $currSliderControl = e.delegateTarget;

    if ($currSliderControl.getAttribute('data-toggle') === 'next') {
        $newSeat = next($el);
        $carousel.classList.remove('is-reversing');
    } else {
        $newSeat = prev($el);
        $carousel.classList.add('is-reversing');
    }

    // Set new active seat
    $seats.forEach(seat => seat.classList.remove('is-ref', 'is-prev', 'is-next', 'visible'));

    if ($newSeat === $seats[0]) {
        $seats.forEach(seat => seat.classList.remove('is-prev', 'is-next'));
        void $carousel.offsetWidth;
    }

    $newSeat.classList.add('is-ref', 'visible');

    if ($newSeat !== $seats[0]) {
        prev($newSeat).classList.add('is-prev', 'visible');
        next($newSeat).classList.add('is-next', 'visible');
    }

    // Update step count
    $bookingStep.innerHTML = $seats.indexOf($newSeat) + 1;
}

function next($el) {
    let $seats = getSeats();
    let currentIndex = $seats.indexOf($el);
    return $seats[(currentIndex + 1) % $seats.length]; // Loops back to first after last
}

function prev($el) {
    let $seats = getSeats();
    let currentIndex = $seats.indexOf($el);
    return $seats[(currentIndex - 1 + $seats.length) % $seats.length]; // Loops back to last after first
}

initializeCarousel();

// Swipe detection
if ($carousel) {
    $carousel.addEventListener('touchstart', handleTouchStart, false);
    $carousel.addEventListener('touchend', handleTouchEnd, false);
}

let swipeStart = 0;

function handleTouchStart(e) {
    const touchStart = e.touches[0];
    swipeStart = touchStart.clientX;
}

function handleTouchEnd(e) {
    const touchEnd = e.changedTouches[0];
    const swipeDistance = swipeStart - touchEnd.clientX;

    if (swipeDistance > 50) {
        toggleBookingHandler({delegateTarget: document.querySelector('.arrow-icon-next')});
    } else if (swipeDistance < -50) {
        toggleBookingHandler({delegateTarget: document.querySelector('.arrow-icon-prev')});
    }
}

// Open popups
const popupTriggerBtns = document.querySelectorAll(".js-popupTrigger")

popupTriggerBtns.forEach(popupTriggerBtn => {
    popupTriggerBtn.addEventListener('click', () => {

        let popupContents = document.querySelectorAll('.js-popup');

        popupContents.forEach(tabContent => {
            tabContent.classList.remove('active')
        })

        let target = document.getElementById(popupTriggerBtn.dataset.popupTarget);
        target.classList.add("active");
    })
})

// Close popups
const popupCloseBtns = document.querySelectorAll(".js-popupClose")

popupCloseBtns.forEach(popupCloseBtn => {
    popupCloseBtn.addEventListener('click', () => {

        let popupContents = document.querySelectorAll('.js-popup');

        popupContents.forEach(tabContent => {
            tabContent.classList.remove('active')
        })
    })
})

function initLazyLoadVideos() {
    const videos = document.querySelectorAll('video[data-src]');

    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const video = entry.target;
                    const src = video.getAttribute('data-src');

                    if (src && !video.querySelector('source')) {
                        const source = document.createElement('source');
                        source.src = src;
                        source.type = 'video/mp4';

                        video.appendChild(source);
                        video.load();
                        observer.unobserve(video);
                    }
                }
            });
        }, {
            threshold: 0.25
        });

        videos.forEach(video => observer.observe(video));
    } else {
        videos.forEach(video => {
            const src = video.getAttribute('data-src');
            if (src && !video.querySelector('source')) {
                const source = document.createElement('source');
                source.src = src;
                source.type = 'video/mp4';
                video.appendChild(source);
                video.load();
            }
        });
    }
}

function initAutoplayVideoFromHash() {
    const hash = window.location.hash;
    if (!hash) return;

    const section = document.querySelector(hash);
    if (!section) return;

    const video = section.querySelector('video');
    if (!video) return;

    section.scrollIntoView({behavior: 'smooth', block: 'center'});

    setTimeout(() => {
        const sourceLoaded = video.querySelector('source');
        if (!sourceLoaded) {
            const src = video.getAttribute('data-src');
            if (src) {
                const source = document.createElement('source');
                source.src = src;
                source.type = 'video/mp4';
                video.appendChild(source);
                video.load();
            }
        }

        video.muted = true;
        video.play().catch(err => console.warn('Autoplay blocked', err));
    }, 800);
}

function initShareButtons() {
    document.querySelectorAll('.share-btn').forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault();

            const vlogIdentifier = button.dataset.id;
            const query = window.location.search;
            const shareUrl = `${window.location.origin}${window.location.pathname}${query}#${vlogIdentifier}`;

            copyToClipboard(shareUrl);
        });
    });
}

function copyToClipboard(text) {
    navigator.clipboard.writeText(text).then(() => {
        showToast('success', translatedText['Link copied to clipboard']);
    }).catch(() => {
        showToast('error', translatedText['Could not copy link']);
    });
}

function showToast(type, message) {
    Swal.fire({
        icon: type,
        title: message,
        toast: true,
        position: 'top-end',
        iconColor: 'white',
        customClass: {
            popup: 'colored-toast'
        },
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true
    });
}
